import 'normalize.css';
import Vue from 'vue';
import * as Sentry from '@sentry/vue';
import App from './App.vue';
import router from './router';
import store from './store';
// directives
import directiveCase from './directives/case';
import directiveCleave from './directives/cleave';
// 3rd party plugins
import moment from 'moment';
import { ClientTable } from 'vue-tables-2';
// GTM 事件追蹤
import { pushToDataLayer } from './helpers/gtm';
// Meta 廣告追蹤：進站時先把 fbclid 存起來（SPA 換頁後網址參數會消失）
import { captureFbclid } from './helpers/meta';

captureFbclid();

Vue.directive('case', directiveCase);
Vue.directive('cleave', directiveCleave);

// https://matanya.gitbook.io/vue-tables-2/installation#register-the-component-s
Vue.use(ClientTable, {
  customFilters: [
    {
      name: 'filterByDateRange',
      callback: (row, query) => {
        const {
          dateFrom,
          dateTo,
        } = query;
        return moment(row.date).isBetween(dateFrom, dateTo);
      },
    },
  ],
}, true);

import axios from 'axios';
const baseUrl = process.env.NODE_ENV === 'development'
  ? 'https://beta.sfdc-api.teach4taiwan.org/'
  : 'https://sfdc-api.teach4taiwan.org/';
axios.defaults.baseURL = baseUrl;
Vue.prototype.axios = axios;

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

Vue.config.productionTip = false;
Vue.use(Loading, {
  canCancel: false,
  color: '#000000',
  loader: 'dots',
  width: 50,
  height: 50,
  backgroundColor: '#ffffff',
  isFullPage: true,
  opacity: 0.3,
});

Sentry.init({
  Vue,
  dsn: 'https://af809adaf10f47806890c6dfc6cc2c3e@o4509877138227200.ingest.us.sentry.io/4509905173020672',
  sendDefaultPii: true,
  debug: process.env.NODE_ENV === 'development',
  environment: process.env.NODE_ENV,
  // Replay
  integrations: [
    Sentry.replayIntegration()
  ],
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

// 將 Sentry 暴露到全局範圍以便調試
if (process.env.NODE_ENV === 'development') {
  window.Sentry = Sentry;
}

// GTM 事件追蹤 - 替代 vue-gtag，使用 dataLayer 推送事件
Vue.prototype.$gtag = {
  event: (eventName, eventData) => {
    pushToDataLayer(eventName, eventData);
  },
};

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
